






import Title from './Title'
export default {
  components: { Title },
  props: {
    hasTitle: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
